import { SvgIconProps } from './icon-props';

export default function ChevronLeft({ height = 180, width = 99 }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			data-name="Layer 1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 99 180"
		>
			<path fill="#231f20" fillRule="evenodd" d="M99 0 9 81l-9 9 9 9 90 81v-18L18 90l81-72V0z" />
		</svg>
	);
}
